import React from 'react';
import Container from './components/container';
import './assets/styles/bootstrap/css/bootstrap.min.css';
import './assets/styles/menu.css';

function App() {
    return (
        <Container />
    );
}


export default App;

